var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5684 1.39393C19.9826 0.808143 19.0329 0.808143 18.4471 1.39393L10.9188 8.92222L3.80642 1.80987C3.22063 1.22408 2.27088 1.22408 1.6851 1.80987C1.09931 2.39565 1.09931 3.3454 1.6851 3.93119L8.79745 11.0435L1.39393 18.4471C0.808143 19.0329 0.808143 19.9826 1.39393 20.5684C1.97972 21.1542 2.92946 21.1542 3.51525 20.5684L10.9188 13.1649L18.7382 20.9843C19.324 21.5701 20.2738 21.5701 20.8596 20.9843C21.4453 20.3985 21.4453 19.4488 20.8596 18.863L13.0401 11.0435L20.5684 3.51525C21.1542 2.92946 21.1542 1.97972 20.5684 1.39393Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClear);
export default __webpack_public_path__ + "static/media/whiteClear.3f7eb0f7c3c021c2732b795e9419b579.svg";
export { ForwardRef as ReactComponent };